import React, { useState, useEffect } from 'react';
import { profileStore } from 'src/hooks/profile';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import Profile from '@system/config/profile';
import Helper from 'src/helper/Helper';
import liveAuth from 'src/helper/liveAuth';
import { Tooltip } from 'src/component/Global/Tooltip';

const LinkToExistingAccount = () => {
    const { numericPattern, onlyNumberPattern, companyNamePattern, alphaNum, addressPattern, ProfileTab: { ProfileInfo } } = Constants

    const [{ profile_user_information }, { get_profile_account_information }, { set_account_link_data, check_valid_account }] = profileStore();
    const emailPattern = Helper.getEmailPattern();

    const initialAccountState = {
        accountNumber: "",
        companyName: "",
        representativeName: "",
        address1: "",
        representativeEmail: "",
        address2: "",
        representativeNumber: "",
        city: "",
        zip: "",
        country: "",
        firstName: "",
        lastName: "",
        email: "",
        mobileNumber: "",
    };

    const [accountValidation, setAccountValidation] = useState({});
    const [accountData, setAccountData] = useState(initialAccountState)
    const [accountNumberChanged, setAccountNumberChanged] = useState(true);
    const [accountNumberError, setAccountNumberError] = useState(false);

    useEffect(() => {
        async function fetchHere() {
            await get_profile_account_information();
        }
        fetchHere()
    }, [])

    useEffect(() => {
        setAccountData(prevState => ({
            ...prevState,
            firstName: profile_user_information?.firstName,
            lastName: profile_user_information?.lastName,
            email: profile_user_information?.emailAddress,
            mobileNumber: profile_user_information?.mobileNumber,
        }))
    }, [profile_user_information])

    const goBack = () => {
        const tab = ProfileInfo
        window.location.href = Profile.getProfileURL() + `?tab=${tab}`;
    }

    const onAccountValueChange = (field, value) => {
        if (accountValidation && Object.keys(accountValidation).length > 0) {
            delete accountValidation[field];
        }
        if (field === 'accountNumber') {
            setAccountNumberChanged(true)
            setAccountNumberError(false)
        }
        setAccountData(prevState => ({ ...prevState, [field]: value }));
    };

    const onSave = async () => {
        let isValid = await onValidateAccountData();
        if (isValid) {
            const accountParams = {
                accountNumber: accountData?.accountNumber,
                avnetRepresentativeName: accountData?.representativeName,
                avnetRepresentativeEmail: accountData?.representativeEmail,
                avnetRepresentativePhone: accountData?.representativeNumber,
                company: accountData?.companyName,
                addressLineOne: accountData?.address1,
                addressLineTwo: accountData?.address2,
                city: accountData?.city,
                postalCode: accountData?.zip,
                country: accountData?.country,
                firstName: accountData?.firstName || "",
                lastName: accountData?.lastName || "",
                phoneNumber: accountData?.mobileNumber || "",
                email: accountData?.email || ""
            }

            try {
                const accountData = await set_account_link_data(accountParams)
                if (accountData?.isSuccessFull) {
                    sessionStorage.setItem(System?.storageName?.ACCOUNT_LINK_SUCCESS_MESSAGE, true)
                    goBack()
                }
            } catch (error) {
                console.log("error in link account", error)
            }
        }
    };

    const validateAccount = async () => {
        const params = {
            account_number: accountData?.accountNumber
        }
        const res = await check_valid_account(params)

        if (res?.data === "True") {
            return true
        } else {
            return false;
        }
    }

    const onValidateAccountData = async () => {
        let validationModal = {};
        if (!Helper.valueIsNotNull(accountData.accountNumber)) {
            setAccountNumberError(false)
            validationModal.accountNumber = "A account number is required.";
        }
        if (!Helper.validateRegex(accountData.accountNumber, numericPattern)) {
            setAccountNumberError(false)
            validationModal.accountNumber = "A valid account number is required.";
        }
        if (Helper.valueIsNotNull(accountData.accountNumber) && Helper.validateRegex(accountData.accountNumber, numericPattern) && accountNumberChanged) {
            const isValid = await validateAccount()
            if (!isValid) {
                setAccountNumberChanged(false)
                setAccountNumberError(true)
                validationModal.accountNumber = "There was no match against the account number entered. Please provide a valid account number.";
            } else {
                setAccountNumberError(false)
            }
        }
        if (accountNumberError) {
            validationModal.accountNumber = "There was no match against the account number entered. Please provide a valid account number.";
        }
        if (Helper.valueIsNotNull(accountData.representativeEmail) && !Helper.validateRegex(accountData.representativeEmail, emailPattern)) {
            validationModal.representativeEmail = "Invalid email. Special characters (-+.'_) must be followed by letters or numbers.";
        }
        if (Helper.valueIsNotNull(accountData.representativeNumber) && !Helper.validateRegex(accountData.representativeNumber, alphaNum)) {
            validationModal.representativeNumber = "A valid phone number is required.";
        }
        if (Helper.valueIsNotNull(accountData.companyName) && !Helper.validateRegex(accountData.companyName, companyNamePattern)) {
            validationModal.companyName = "A valid company name is required.";
        }
        if (Helper.valueIsNotNull(accountData.city) && !Helper.validateRegex(accountData.city, addressPattern)) {
            validationModal.city = "A valid City is required.";
        }
        if (Helper.valueIsNotNull(accountData.address1) && !Helper.validateRegex(accountData.address1, addressPattern)) {
            validationModal.address1 = "A valid address is required.";
        }
        if (Helper.valueIsNotNull(accountData.address2) && !Helper.validateRegex(accountData.address2, addressPattern)) {
            validationModal.address2 = "A valid address is required.";
        }
        if (Helper.valueIsNotNull(accountData.zip) && !Helper.validateRegex(accountData.zip, onlyNumberPattern)) {
            validationModal.zip = "A valid Zip/Postal Code is required.";
        }
        if (Helper.valueIsNotNull(accountData.zip) && accountData.zip.length < 5) {
            validationModal.zip = "Please enter at least 5 digits."
        }
        if (Helper.valueIsNotNull(accountData.country) && !Helper.validateRegex(accountData.country, addressPattern)) {
            validationModal.country = "A valid Country Name is required.";
        }
        setAccountValidation(validationModal);
        Helper.scrollTop()
        return Object.keys(validationModal).length === 0;
    };

    const RequestUserSignIn = () => {
        return (
            <div>
                <div className="container text-center mt-5 mb-5 access-denied">
                    <h1 className="font-oswald font-light text-green">
                        We're Sorry! You do not have access to this content.
                    </h1>
                    <hr />
                    <p>
                        You've reached a page that requires Sign In. If you are signed in
                        and don't have <br /> permission to view the page contact{" "}
                        <a href="mailto:onlinesupporteu@avnet.com" className="text-blue">
                            online support.
                        </a>
                    </p>
                </div>
            </div>
        );
    };


    return (
        <>
            {liveAuth.check() ?
                <div className='container profile-container linktoexisting'>
                    <div class="page-title font-oswald font-light font-38 mb-3 mb-sm-0">REQUEST TO LINK TO AN EXISTING ACCOUNT</div>
                    <div className="bs5 row mt-2">
                    </div>
                    <hr />
                    <p className='pt-2 pb-2'>If you are a customer with an existing terms and conditions purchasing account, complete this form to request to be linked to an existing account.</p>
                    <hr />

                    <form>
                        <div className="font-weight-normal font-24 mb-1">Link to Existing Account Details</div>
                        <p className="font-13 font-arial mb-3">Providing the following Avnet details will assist Linking to an Existing Account.</p>

                        <div className="bs5 row mt-2">
                            <div className="col-5">
                                <div className='bs5 row'>

                                    <div className="col-12">
                                        <div className="form-group w-90">
                                            <label htmlFor="accountNumber" className="d-block">Account Number*</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.accountNumber ? "error" : ""}`}
                                                id="accountNumber"
                                                placeholder="Account Number"
                                                name="accountNumber"
                                                value={accountData.accountNumber}
                                                onChange={({ target: { value } }) => onAccountValueChange("accountNumber", value)}
                                            />
                                            <i className='mt-1 d-inline-block'>
                                                Link to this Account Number (Add 00 as a prefix to the Account Number)</i>
                                            <Tooltip position={'bottom center'}
                                                opener={() => <i className="fa fa-info-circle ms-1" />}
                                                content={() => (
                                                    <div>
                                                        Account number must be <br></br> proceeded with two zeros (00).<br></br>i.e. 55466 enter 0055466
                                                    </div>
                                                )}

                                            />

                                            {accountValidation.accountNumber && <p className="error">{accountValidation.accountNumber}</p>}
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-group w-90">
                                            <label htmlFor="representativeName" className="d-block">Avnet Representative Name</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.representativeName ? "error" : ""}`}
                                                id="representativeName"
                                                placeholder="Name"
                                                name="representativeName"
                                                value={accountData.representativeName}
                                                maxLength={20}
                                                onChange={({ target: { value } }) => {
                                                    const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
                                                    onAccountValueChange("representativeName", filteredValue)
                                                }} />

                                            {accountValidation.representativeName && <p className="error">{accountValidation.representativeName}</p>}
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-group w-90">
                                            <label htmlFor="representativeEmail" className="d-block">Avnet Representative Email</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.representativeEmail ? "error" : ""}`}
                                                id="representativeEmail"
                                                placeholder="Email Address"
                                                name="representativeEmail"
                                                maxLength={185}
                                                value={accountData.representativeEmail}
                                                onChange={({ target: { value } }) => onAccountValueChange("representativeEmail", value)}
                                            />
                                            {accountValidation.representativeEmail && <p className="error">{accountValidation.representativeEmail}</p>}
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-group w-90">
                                            <label htmlFor="representativeNumber" className="d-block">Avnet Representative Phone Number</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.representativeNumber ? "error" : ""}`}
                                                id="representativeNumber"
                                                placeholder="Phone Number"
                                                name="representativeNumber"
                                                maxLength={20}
                                                value={accountData.representativeNumber}
                                                onChange={({ target: { value } }) => {
                                                    const filteredValue = value.replace(/[^\d()+\-\/\s]/g, ''); // Only allowed characters
                                                    onAccountValueChange("representativeNumber", filteredValue);
                                                }}
                                            />
                                            {accountValidation.representativeNumber && <p className="error">{accountValidation.representativeNumber}</p>}
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="col-5">
                                <div className='row'>
                                    <div className="col-12">
                                        <div className="form-group w-90">
                                            <label htmlFor="companyName" className="d-block">Company Name</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.companyName ? "error" : ""}`}
                                                id="companyName"
                                                placeholder="Company Name"
                                                name="companyName"
                                                maxLength={35}
                                                value={accountData.companyName}
                                                onChange={({ target: { value } }) => onAccountValueChange("companyName", value)}
                                            />
                                            {accountValidation.companyName && <p className="error">{accountValidation.companyName}</p>}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group w-90">
                                            <label htmlFor="address1" className="d-block">Address 1</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.address1 ? "error" : ""}`}
                                                id="address1"
                                                placeholder="Address 1"
                                                name="address1"
                                                maxLength={35}
                                                value={accountData.address1}
                                                onChange={({ target: { value } }) => onAccountValueChange("address1", value)}
                                            />
                                            {accountValidation.address1 && <p className="error">{accountValidation.address1}</p>}
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-group w-90">
                                            <label htmlFor="address2" className="d-block">Address 2</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.address2 ? "error" : ""}`}
                                                id="address2"
                                                placeholder="Address 2"
                                                name="address2"
                                                maxLength={35}
                                                value={accountData.address2}
                                                onChange={({ target: { value } }) => onAccountValueChange("address2", value)}
                                            />
                                            {accountValidation.address2 && <p className="error">{accountValidation.address2}</p>}
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-group w-90">
                                            <label htmlFor="city" className="d-block">City</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.city ? "error" : ""}`}
                                                id="city"
                                                placeholder="City Name"
                                                name="city"
                                                value={accountData.city}
                                                onChange={({ target: { value } }) => onAccountValueChange("city", value)}
                                                maxLength={35}
                                            />
                                            {accountValidation.city && <p className="error">{accountValidation.city}</p>}
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group  w-90">
                                            <label htmlFor="zip" className="d-block">Zip/Postal Code</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.zip ? "error" : ""}`}
                                                id="zip"
                                                placeholder="Zip/Postal Code"
                                                name="zip"
                                                maxLength={40}
                                                value={accountData.zip}
                                                onChange={({ target: { value } }) => onAccountValueChange("zip", value)}
                                            />
                                            {accountValidation.zip && <p className="error">{accountValidation.zip}</p>}
                                        </div>
                                    </div>

                                    <div className="col-6">
                                        <div className="form-group  w-90">
                                            <label htmlFor="country" className="d-block">Country</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.country ? "error" : ""}`}
                                                id="country"
                                                placeholder="Country Name"
                                                name="country"
                                                value={accountData.country}
                                                onChange={({ target: { value } }) => onAccountValueChange("country", value)}
                                            />
                                            {accountValidation.country && <p className="error">{accountValidation.country}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr />
                        <div className="page-title font-oswald font-light font-24 mb-1">Personal Details</div>
                        <p className="font-13 font-arial mb-3">Personal details are not editable.</p>

                        <div className="bs5 row">
                            <div className="col-5">
                                <div className="form-group w-90">
                                    <label htmlFor="firstName" className="d-block">First Name*</label>
                                    <input
                                        type="text"
                                        readOnly
                                        className={`form-control form-control-sm cursor-not-allowed readonly-field`}
                                        id="firstName"
                                        placeholder="First Name"
                                        name="firstName"
                                        defaultValue={accountData.firstName}
                                        maxLength={50}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="bs5 row">
                            <div className="col-5">
                                <div className="form-group w-90">
                                    <label htmlFor="lastName" className="d-block">Last Name*</label>
                                    <input
                                        type="text"
                                        readOnly
                                        className={`form-control form-control-sm cursor-not-allowed readonly-field`}
                                        id="lastName"
                                        placeholder="Last Name"
                                        name="lastName"
                                        defaultValue={accountData.lastName}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="bs5 row">
                            <div className="col-5">
                                <div className="form-group w-90">
                                    <label htmlFor="phoneNumber" className="d-block">Phone Number*</label>
                                    <input
                                        type="text"
                                        readOnly
                                        className={`form-control form-control-sm cursor-not-allowed readonly-field`}
                                        id="phoneNumber"
                                        placeholder="Phone Number"
                                        name="phoneNumber"
                                        defaultValue={accountData.mobileNumber}
                                        maxLength={32}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="bs5 row">
                            <div className="col-5">
                                <div className="form-group w-90">
                                    <label htmlFor="email" className="d-block">Email*</label>
                                    <input
                                        type="text"
                                        readOnly
                                        className={`form-control form-control-sm cursor-not-allowed readonly-field`}
                                        id="email"
                                        placeholder="Email Address"
                                        name="email"
                                        defaultValue={accountData.email}
                                        maxLength={185}
                                    />
                                </div>
                            </div>
                        </div>

                        <hr />
                        <button type="button" className="bs5 btn btn-primary me-3 minw150" onClick={onSave}>Submit</button>
                        <button type="button" className="bs5 btn btn-secondary minw150" onClick={goBack}>Cancel</button>

                        <p className='mt-5 mb-3'>Avnet, Inc. ("Avnet") <a target='_blank' href={System.getTermsAndConditionURL()}>Terms and Conditions</a> and <a target='_blank' href={System.getTermsOfUse()}>Terms of Use</a> are applicable laws and regulations governing the Site.</p>
                    </form>
                </div>
                : <RequestUserSignIn />}
        </>
    )
}
export default LinkToExistingAccount;